import { createContext, ReactNode, Dispatch, SetStateAction } from 'react'

import { SanityInstitutionItem } from '@data/sanity/queries/types/institution'
import { useLocalStorageState } from './helpers'
import { Locale } from './language'
import { getInstitutionIdStorageKey } from './local-storage'

interface InstitutionContextProps {
  institutions: SanityInstitutionItem[]
  institutionId: string
  setInstitutionId: Dispatch<SetStateAction<string>>
}

export const InstitutionContext = createContext<InstitutionContextProps>({
  institutions: [],
  institutionId: '',
  setInstitutionId: () => null,
})

interface InstitutionContextProviderProps {
  locale: Locale
  institutions: SanityInstitutionItem[]
  children: ReactNode
}

export const InstitutionContextProvider = ({
  locale,
  institutions,
  children,
}: InstitutionContextProviderProps) => {
  const localStorageKey = getInstitutionIdStorageKey(locale)
  const [institutionId, setInstitutionId] = useLocalStorageState<string>(
    localStorageKey,
    '',
  )

  return (
    <InstitutionContext.Provider
      value={{
        institutions,
        institutionId,
        setInstitutionId,
      }}
    >
      {children}
    </InstitutionContext.Provider>
  )
}
